import React from 'react';
import { useQuery } from '@apollo/client/react/hooks';

import LoadingProgress from 'lib/react-router/loading-progress';
import { RouteWithSearchRenderProps } from 'lib/react-router/route-with-search';

import ErrorPage from 'four-nets/errors/error-page';
import UserBazaarView from 'four-nets/bazaar/user-bazaar/user-bazaar-view';

import userQuery, { BazaarUserQuery, BazaarUserQueryVariables } from './user-query.graphql';
import productsQuery, { UserProductsESQuery, UserProductsESQueryVariables } from './user-bazaar-loader.graphql';
import { ProductsOrderBy } from './user-bazaar-loader.graphql.types';

interface Params {
    username: string;
}

interface Search {
    page?: number;
    orderBy?: ProductsOrderBy;
}

export interface Props extends RouteWithSearchRenderProps<Params, Search> {}

const UserBazaarLoader: React.FC<Props> = React.memo(props => {
    const {
        search: { page, orderBy },
        match: {
            params: { username },
        },
    } = props;

    const {
        loading: productLoading,
        error: productError,
        data: productData,
    } = useQuery<UserProductsESQuery, UserProductsESQueryVariables>(productsQuery, {
        variables: {
            page,
            orderBy,
            username,
        },
    });

    const {
        loading: userLoading,
        error: userError,
        data: userData,
    } = useQuery<BazaarUserQuery, BazaarUserQueryVariables>(userQuery, {
        variables: {
            username,
        },
    });

    const user =
        userData &&
        userData.users &&
        userData.users.edges &&
        userData.users.edges.length == 1 &&
        userData.users.edges[0] &&
        userData.users.edges[0]!!.node;

    const userBazaarFragment = productData && productData.products;

    return (
        <LoadingProgress loading={productLoading || userLoading}>
            <ErrorPage error={productError || userError}>
                {user && userBazaarFragment ? (
                    <UserBazaarView
                        orderBy={orderBy || ProductsOrderBy.UPDATED}
                        currentProductPage={page || 1}
                        userBazaarFragment={userBazaarFragment}
                        {...user}
                    />
                ) : null}
            </ErrorPage>
        </LoadingProgress>
    );
});

export default UserBazaarLoader;
